/**
 * Strip ---BEGIN/END--- delimiters from artifact content before rendering.
 */
export function sanitizeArtifactContent(content: string): string {
  if (!content) return "";
  return content
    .replace(/^---BEGIN [A-Z\s]+---\n?/m, "")
    .replace(/\n?---END [A-Z\s]+---$/m, "")
    .trim();
}
